import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
    mutation StripeReSubscribeMutation($input: Stripe__ReSubscribeInput!) {
        stripeReSubscribe(input: $input) {
            success
            error
        }
    }
`;

const commit = () =>
  createMutation({
      mutation,
      variables: {
          input: {}
      }
  });

export default { commit };
